module.exports = __webpack_public_path__ + "img/Ice-Cream.6a737b44.svg";